// P39 TR-019 -- the free-text length the student backend accepts.
//
// Mirrors Subway's SF_FREE_TEXT_MAX (StudentProfileService.ts, applied to
// `cityManual` and `schoolName` in the profile PATCH, and in
// UserCreationService.ts for registration). Subway trims first, then rejects a
// value longer than this, so a longer value only ever surfaces as a generic
// save error. `maxlength` counts UTF-16 units, like Subway's `.length`.
//
// First name, last name and e-mail have no backend cap and get none here.
export const STUDENT_FREE_TEXT_MAX = 120
